import Combobox from "./combobox_controller"

// "Firma" field. Picking a customer shows its address and starts the branch
// section over; typing a name nobody has yet creates a new customer on save.
export default class extends Combobox {
  static outlets = ["branch-select", "address-fields"]

  get customerId() {
    return this.hiddenTarget.value
  }

  optionSubtitle(item) {
    return item.address?.line
  }

  applySelection(item) {
    this.hiddenTarget.value = item.id
    this.addressFieldsOutlet.assign(item.address)
    if (this.hasBranchSelectOutlet) this.branchSelectOutlet.clearAll()
  }

  detach() {
    this.hiddenTarget.value = ""
    if (this.hasBranchSelectOutlet) this.branchSelectOutlet.detach()
  }

  clear() {
    this.detach()
    this.addressFieldsOutlet.assign(null)
    if (this.hasBranchSelectOutlet) this.branchSelectOutlet.clearAll()
  }

  // Filled in by the branch dropdown when a branch of another customer is picked.
  assign(customer) {
    this.inputTarget.value = customer?.name || ""
    this.hiddenTarget.value = customer?.id || ""
    this.addressFieldsOutlet.assign(customer?.address)
    this.refresh()
  }
}
